export interface MobileRelease {
  enabled: boolean;
  packageId: string;
  versionCode: number;
  versionName: string;
  minimumVersionCode: number;
  mandatory: boolean;
  notes: string;
  apkUrl: string;
  sha256: string;
  sizeBytes: number;
  minSdk: number;
}
export interface MobileVersion {
  revision: number;
  release: MobileRelease;
  author: string;
  at: string;
}
export interface MobileSettings {
  published: MobileVersion | null;
  draft: MobileVersion | null;
  versions: MobileVersion[];
}
export const emptyMobileRelease: MobileRelease = {
  enabled: false,
  packageId: "br.com.gabinetecentral.app",
  versionCode: 1,
  versionName: "0.1.0",
  minimumVersionCode: 1,
  mandatory: false,
  notes: "",
  apkUrl: "",
  sha256: "",
  sizeBytes: 0,
  minSdk: 26,
};
